import React from 'react'
import { SocialIcon } from 'react-social-icons'
import { Images } from '../../constants'

const Footer = () => {
  return (
    <div className='bg-[#191F25] py-10 p-5  flex flex-col lg:flex-row '>

      <div className='flex flex-col lg:w-1/5'>
        <img draggable={false}  src={Images.LOGO2} alt="logo" className=' mr-auto w-2/6 py-2' />
        <p className='text-white poppins-regular select-none'>Where innovation meets elegance</p>
        <p className='text-white poppins-light text-sm select-none'>Copyright © 2024 Techaso Pvt Ltd</p>
      </div>
     
     <div className='lg:w-1/5 pt-5 lg:pt-0 '>
      <h1 className='text-white poppins-bold '>COMPANY</h1>
      <p className='cursor-pointer text-white py-1'>Works</p>
      <p className='cursor-pointer text-white py-1'>About Us</p>
      <p className='cursor-pointer text-white py-1'>Our Team</p>

     </div>
     <div className='lg:w-1/5 pt-5 lg:pt-0'>
      <h1 className='text-white poppins-bold '>SERVICES</h1>
      <p className='cursor-pointer text-white lg:py-1'>Web Development</p>
      <p className='cursor-pointer text-white lg:py-1'>E-commerce Development</p>
      <p className='cursor-pointer text-white lg:py-1'>Mobile App Development</p>
      <p className='cursor-pointer text-white lg:py-1'>Maintenance and Support</p>
      <p className='cursor-pointer text-white lg:py-1'>Digital Marketing Integration</p>
     </div>

     <div className='w-1/5 pt-5 lg:pt-0 '>
      <h1 className='text-white poppins-bold'>CONTACT</h1>
      <p className='cursor-pointer text-white py-1'>business.techaso@gmail.com</p>
      <div className='flex-row flex '>
      <SocialIcon draggable={false}  network="linkedin" className='lg:mx-1' href='https://linkedin.com/company/deeze-official/' fgColor='white' bgColor='black'/>
      <SocialIcon draggable={false}  network="github" className='lg:mx-2' href='https://github.com/Deeze-Offical' fgColor='white' bgColor='black' />
      <SocialIcon draggable={false} network="instagram" className='lg:mx-2 ' href='https://www.instagram.com/deeze_innovation/' fgColor='white' bgColor='black' />
        
      </div>
      
      <p className='cursor-pointer lg:px-2 text-white py-1 hidden lg:block'>Made with ❤️ by deeze</p>
     </div>
     <div className='lg:w-1/5 '>
      <div className='flex flex-col'>
        <h1 className='text-white poppins-bold'>Subscribe</h1>
        <input className='rounded mx-3 h-9 my-2 px-2 outline-none' autoComplete='name' placeholder='Name'/>
        <input className='rounded mx-3 h-9 my-2 px-2 outline-none' required placeholder='Email'/>
        <button className='bg-[#7053c0] hover:bg-[#7c5dcf]  mx-3 p-2 rounded-md transition-all duration-300 text-white poppins-bold '>Submit</button>
        <p className='cursor-pointer lg:px-2 text-white py-1 text-center lg:hidden'>Made with ❤️ by deeze</p>

      </div>
     </div>

    </div>
  )
}

export default Footer